/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-use-before-define */
import type { AllowSmartadTargeting } from '~/hooks/queries/useSmartadOptionsQuery/smartadTarget.types';
import { Binary, ErrorObjectString } from '~/utils/typescriptHelpers';
import { CustomFetcher } from '../../../utils/cross-env-utils';

export type NativePricingDefault = 'CPC' | 'CPM' | 'VCPM' | 'selectable';

export type DefaultPricingModel = {
  display: 'CPM' | 'VCPM';
  poll: 'CPM' | 'VCPM';
  native: NativePricingDefault;
};

export type ClientPlData = {
  logo: string | null;
  timezone: string;
  timezoneActive: boolean;
  name: string;
  children?: Children;
  logins: Logins;
  targeting: Targeting;
  parent_client_id: number | null;
  billing_type: 'Invoice' | 'Credit Card' | null | (string & {});
  /**
   * Publisher O&O is for publishers to have a client account to serve their own ads.
   * normally they would pay 0 and have no budget set.
   */
  type: 'Publisher O&O' | (string & {}) | null;
  /** When true with Publisher O&O type, bid price is required on the ad form. */
  oandoPriceEnabled?: boolean;
  billing_capped: Binary | null;
  billing_terms_amount: number | null;
  suspensionReason: 'Dispute' | 'Arrears' | (string & {}) | null;
  // 'C' is normal status, 'Dispute' is when the client is disputing the invoice.
  status: 'C' | 'Dispute' | (string & {});
  // @deprecated
  brandSafetyAccessLevel: 'all' | 'publisher' | 'keyword' | 'none';
  brandSafetyPermissions: {
    publisher: Binary;
    ias: Binary;
    keyword: Binary;
  };
  nativeLine2MaxLength: number;
  defaultPricingModel: DefaultPricingModel;
  allowSmartadTargeting?: AllowSmartadTargeting;
};

export type Children = Record<string, Child>;
export type Child = {
  logo: string | null;
  name: string;
  status: string;
  id: number;
};
type Logins = Record<string, Login>;
type Login = {
  permission_campaign: 0 | 1 | 2;
  permission_invoices: Binary;
  username: string | null;
};
interface Targeting {
  audiences: Audiences;
  partners: Partners;
  geo: Geo;
  keywords: {
    blocking: string;
  };
}
interface Audiences {
  exclude_audience_ids: string[];
  include_audience_ids: string[];
}
interface Partners {
  include_partner_ids: string[];
  standard: boolean | null;
  exclude_partner_ids: string[];
  all: boolean | null;
}
type Region = {
  id: number;
  label: string;
};
interface Geo {
  include_region_ids: string[];
  includeRegions: Region[];
  exclude_region_ids: string[];
  excludeRegions: Region[];
}
type ResponseData = ClientPlData | ErrorObjectString;

export async function getClientInfo({
  id,
  fetcher,
}: {
  id: number | string | null | undefined;
  fetcher: CustomFetcher;
}) {
  if (id == null) {
    throw new Error('No client id provided');
  }
  let requestOptions = {};

  requestOptions = {
    useNodeEndpoint: true,
  };

  const { data } = await fetcher.get<ResponseData>(`/authenticated/client/${id}`, requestOptions);

  if ('error' in data) {
    throw new Error(data.error);
  }
  return { ...data, isParent: !!data.children, isChild: data.parent_client_id !== null };
}
